export function dashString(text?: string | null): string {
  return text || '-';
}
